export class Requirement {
    constructor() {
        /**
         * @var stake List of stake
         */
        this.stakes = [];
        /**
         * @var actors List of actors who gone used the futur system
         */
        this.actors = [];
        /**
         * @var datas List of datas
         */
        this.datas = [];
        /**
         * @var actions Actions which can be done
         */
        this.actions = [];
        /**
         * @var questions
         */
        this.questions = [];
        // this.title = "Titre de test";
        // this.description = "Description pour le test";
        this.info = new RequirementInfo();
        // this.info.title = "Titre de test";
        // this.info.description = "Description pour le test";
        // For dev
        // this.stakes = ["Premier enjeu", "Deuxième enjeu", "Troisième enjeu"]
        // this.actors = ["Sean Connery", "Timothy Dalton", "Brad Pitt"]
        // this.datas = ["Vaches", "Cheptel", "Elevage", "Eleveur"]
    }
}
export class RequirementInfo {
    constructor() {
        this.title = "";
        this.description = "";
    }
}
export class RequirementAction {
    constructor() {
        this.label = "";
        this.actors = [];
        this.datas = [];
    }
}
